export const COMMON_UPDATE_ERROR = 'COMMON_UPDATE_ERROR';
export const COMMON_UPDATE_EMPTY_ERROR = 'COMMON_UPDATE_EMPTY_ERROR';
export const COMMON_UPDATE_ERROR_GROUP = 'COMMON_UPDATE_ERROR_GROUP';

export const updateError = (error) => ({
  type: COMMON_UPDATE_ERROR,
  error
});

export const updateErrorGroup = (error) => ({
  type: COMMON_UPDATE_ERROR_GROUP,
  error
});

export const updateEmptyError = () => ({
  type: COMMON_UPDATE_EMPTY_ERROR
});
